export const lang = {
    lang: '这特么是中文'
}